// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-wrap {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: #edeeee;
  z-index: 1000;
}

.logo {
  width: 380px;
  height: 55px;
  margin: 50px auto 50px;
  background-image: url('logo2.png');
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
}

.loading {
  border-radius: 50%;
  margin: 0 auto;
  z-index: 100;
}

.loading.lg {
  width: 100px;
  height: 100px;
  border: 14px solid rgba(89, 101, 118, 0.32);
  ;
  border-top-color: #0255A5;
}
.loading-message {
  padding-top: 20px;
  text-align: center;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/page-loader/page-loader.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kCAA2C;EAC3C,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;;EAE3C,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".loader-wrap {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n  background-color: #edeeee;\n  z-index: 1000;\n}\n\n.logo {\n  width: 380px;\n  height: 55px;\n  margin: 50px auto 50px;\n  background-image: url(assets/img/logo2.png);\n  position: relative;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.loading {\n  border-radius: 50%;\n  margin: 0 auto;\n  z-index: 100;\n}\n\n.loading.lg {\n  width: 100px;\n  height: 100px;\n  border: 14px solid rgba(89, 101, 118, 0.32);\n  ;\n  border-top-color: #0255A5;\n}\n.loading-message {\n  padding-top: 20px;\n  text-align: center;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
